import { couponApi } from "@api";
import { ComponentBread, ComponentHeader, DeleteIcon, StyledCreate } from "@components";
import { PATH_COUPON_LIST, PATH_CREATE_COUPON_FAMILY } from "@configs";
import { ICouponProgram, ICouponService } from "@interfaces";
import { setLoading } from "@redux";
import { useNotify } from "@utils";
import { Button } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { CdicServiceForm } from "src/Modules/coupon/Service";
import styled from "styled-components";

export const PageCreateCdicService = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { error } = useNotify();
  const { t } = useTranslation();
  const [coupon, setCoupon] = useState<ICouponProgram>();
  const [service, setService] = useState<ICouponService[]>([]);
  const data = [
    {
      title: <a href={PATH_COUPON_LIST}>{t("page.coupon_management")}</a>,
    },
    {
      title: <a href={"/"}>{t("page.selected_program_name")}</a>,
    },
    {
      title: <a href={PATH_CREATE_COUPON_FAMILY}>{t("page.create_service")}</a>,
    },
  ];

  useEffect(() => {
    if (id) {
      fetchCouponProgram();
    }
  }, [id]);

  useEffect(() => {
    searchService();
  }, ['fetch service']);

  

  const fetchCouponProgram = async () => {
    try {
      dispatch(setLoading(true));
      const res = await couponApi.getProgram(id);
      setCoupon(res.data);
    } catch (err: any) {
      error(t("message.create.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const searchService = async () => {
    try {
      const res = await couponApi.searchServiceNames();
      setService(res.data);
    } catch (err: any) {
      throw new Error(err.message);
    }
  };
  const handleDelete = async (id: string) => {
    try {
      await couponApi.deleteService(id);
      searchService();
    } catch (err: any) {
      throw new Error(err.message);
    }
  };
  return (
    <>
      <ComponentHeader title={t("page.create_coupon_family")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <CdicServiceForm coupon={coupon} />
        <div>
          {service.map((item, index) => (
            <StyledList key={item._id}>
              <div>{index + 1}</div>
              <p>{item.serviceName}</p>
              <Button onClick={() => item._id && handleDelete(item._id)} type="primary" icon={<DeleteIcon />} />
            </StyledList>
          ))}
        </div>
      </StyledCreate>
    </>
  );
};
const StyledList =  styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 200px;
  border-bottom: 1px solid #d9d9d9;
  p {
    margin: 0;
  }
`;

